import { render, staticRenderFns } from "./UpdateRegistration.vue?vue&type=template&id=24cbf64a&scoped=true"
import script from "./UpdateRegistration.vue?vue&type=script&lang=js"
export * from "./UpdateRegistration.vue?vue&type=script&lang=js"
import style0 from "./UpdateRegistration.vue?vue&type=style&index=0&id=24cbf64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbf64a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCheckbox,
  VContainer,
  VDivider,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
  VSelect,
  VSwitch,
  VTextField,
})
